// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f1d1fc5e","483":"7ab37a53"}[chunkId] + ".chunk.js";
};